import styled from 'styled-components';

import StopInfoWindow from './component';

export default styled(StopInfoWindow)`
  .address-row,
  .contact-row {
    font-size: 16px;
    padding: 0;
    margin: 0;
    border: 0;
  }
`;
